﻿<rdo-overlay [enabled]="loadingProductTypesRentalGrowth"></rdo-overlay>

@if (selectedProductTypeService.isProductSelected && data!==null) {
  <rental-growth-grid
  [data]="data"></rental-growth-grid>
}

@if (((!currentYearRaw || !previousYearRaw) && !loadingProductTypesRentalGrowth)) {
  <div class="no-data-available">
    {{'main.tabs.equipment.product_types.no_data_available' | translate}}
  </div>
}

@if (!loadingChart && selectedProductTypeService.isProductSelected && data!==null && chartData!==null) {
  <rdo-rental-growth-chart [chart-data]="chartData" ></rdo-rental-growth-chart>
}
@if (chartData===null && data!==null && loadingChart) {
  <rdo-loader id="chart-loader" class="chart-loader" />
}


